import _ from "lodash";
import {Popconfirm, Tooltip} from "antd";
import Icon from "@ant-design/icons";
import React from "react";
import {
    FINISHED_STATUS,
    QUEUE_STATUS,
    RUNNING_STATUS,
    SUBMITTED_STATUS,
    WAITING_STATUS
} from "../../containers/CohortBuilder/cohortStatus";
import {Success} from "./icons/Success";
import styles from './CohortStatus.module.scss'
import {Danger} from "./icons/Warning";
import {Running} from "../../containers/CohortBuilder/icons/Running";
import {useAppDispatch, useAppSelector} from "../../hooks";
import {getPermissions} from "../../actions/userSlice";
import {canEditQuery, canKillQuery} from "../../containers/CohortBuilder/PermissionsUtil";
import {stopQuery} from "../../containers/CohortBuilder/cohortBuilderSlice";
import {Query} from "../../containers/HealthcareUsageReport/types/CohortQuery";

const RunningStatus = ({testid, query}: {testid: string, query: Query}) => {
    const dispatch = useAppDispatch()
    const permissions = useAppSelector(getPermissions)
    const canStopQuery = canKillQuery(permissions) && canEditQuery(permissions)

    return <Tooltip data-testid={testid} title={"running query"}>
        <Icon className={`${styles.icon} ${styles.green}`} component={Running}/>
        { canStopQuery
            ? <Popconfirm key="3"
                        title="Are you sure you want to stop this query?"
                        onConfirm={() => { dispatch(stopQuery(query.id, query.sparkQuery!.id)) }}
                        okText="Yes"
                        cancelText="No">
                <span className={styles.stop}>Stop Query</span>
            </Popconfirm>
            :  "Running"
        }
    </Tooltip>
}

export const CohortStatus = ({query}: {query: Query | undefined}) => {
    const status = query?.sparkQuery?.status || (query?.sparkQuery?.active ? RUNNING_STATUS : undefined)

    if (_.isNil(query) || _.isNil(status)) {
        return null
    }

    const testid = `query-list-status-${query.id}`
    switch (status.toLowerCase()) {
        case RUNNING_STATUS:
        case WAITING_STATUS:
        case QUEUE_STATUS:
        case SUBMITTED_STATUS:
            return <RunningStatus testid={testid} query={query} />
        case FINISHED_STATUS:
            return <span data-testid={testid}>
                <Icon component={Success} className={styles.icon} />
                Complete
            </span>
        default:
            return <span data-testid={testid}>
                <Icon component={Danger} className={styles.icon} />
                Failed
            </span>
    }
}